// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__fcm2+","content":"Layout_content__XBRdw","data":"Layout_data__rPJRS","noPadding":"Layout_noPadding__MdXW8"};